module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chips"
  }, [_vm._v("#"), _vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-00db991d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Chips.vue
// module id = 287
// module chunks = 1